<div id="main-container">
    <div class="inbox-header" *ngIf="!small_screen">
      <h4>{{ 'KILN_ALERTS.INBOX' | translate }}</h4>
      <ion-button
        size="small"
        (click)="markAllRead()"
        [disabled]="marking_as_read || !sentAlerts || sentAlerts.length === 0">
        {{ 'KILN_ALERTS.MARK_ALL_AS_READ' | translate }}
      </ion-button>
    </div>
    <ion-item color="medium" *ngIf="small_screen">
      <ion-label><h4>{{ 'KILN_ALERTS.INBOX' | translate }}</h4></ion-label>
    </ion-item>
    <ion-grid *ngIf="!small_screen">
      <ion-row>
        <ion-col>{{ 'KILN_ALERTS.FROM' | translate }}</ion-col>
        <ion-col>{{ 'KILN_ALERTS.SUBJECT' | translate }}</ion-col>
        <ion-col>{{ 'KILN_ALERTS.RECEIVED' | translate }}</ion-col>
        <ion-col>{{ 'KILN_ALERTS.READ_OR_MARK_AS_READ' | translate }}</ion-col>
      </ion-row>
      <ion-row *ngIf="viewingKilnlinkFreeKilns">
        <ion-col colspan="4">{{ 'KILN_ALERTS.KILNLINK_FREE_ALERTS_MESSAGE' | translate }}</ion-col>
      </ion-row>
      <ion-row *ngIf="!viewingKilnlinkFreeKilns && gettingAlerts">
        <ion-col colspan="4"><ion-spinner name="bubbles"></ion-spinner> {{ 'KILN_ALERTS.GETTING_ALERTS' | translate }}</ion-col>
      </ion-row>
      <ion-row *ngIf="!viewingKilnlinkFreeKilns && !gettingAlerts && sentAlerts && sentAlerts.length === 0">
        <ion-col colspan="4">{{ 'KILN_ALERTS.NO_ALERTS_SENT' | translate }}</ion-col>
      </ion-row>
      <ion-row *ngFor="let sentAlert of sentAlerts; let i = index;"
        [class.selected]="selectedAlert && i === selectedAlert.index"
        (click)="selectAlert(i)">
        <ion-col>{{sentAlert.kiln_name}}</ion-col>
        <ion-col>{{sentAlert.subject}}</ion-col>
        <ion-col>{{sentAlert.sent_time | date:'MMM dd, yyyy hh:mm zz' }}</ion-col>
        <ion-col *ngIf="sentAlert.is_read">{{sentAlert.read_by_time.sent_time | date:'medium' }}</ion-col>
        <ion-col class="td mark-as-read" *ngIf="!sentAlert.is_read"
          [class.disabled]="marking_as_read">
          <ion-button (click)="markRead(sentAlert.type, sentAlert.alert_id)">{{ 'KILN_ALERTS.MARK_AS_READ' | translate }}</ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-item *ngIf="small_screen && hasSelectedAlert">
      <ion-label *ngIf="selectedAlert" class="ion-text-wrap">{{selectedAlert.subject}}</ion-label>
      <ion-button (click)="showPicker()" [disabled]="!sentAlerts || sentAlerts.length === 0">{{ 'KILN_ALERTS.CHOOSE_ALERT' | translate }}</ion-button>
    </ion-item>

    <!-- Mark as read on small screen when viewing an unread alert -->
    <ion-item *ngIf="small_screen && hasSelectedAlert && !selectedAlert.is_read" lines="full">
      <ion-button
        expand="block"
        (click)="markRead(selectedAlert.type, selectedAlert.alert_id)"
        [disabled]="marking_as_read">
        {{ 'KILN_ALERTS.MARK_AS_READ' | translate }}
      </ion-button>
    </ion-item>
    <ion-item *ngIf="small_screen && hasSelectedAlert && selectedAlert.is_read" lines="full">
      <ion-note>{{ 'KILN_ALERTS.READ_AT' | translate }} {{ selectedAlert.read_by_time?.sent_time | date:'medium' }}</ion-note>
    </ion-item>

  <div id="current-message" *ngIf="hasSelectedAlert">
    <ion-list>
      <ion-item>
        <ion-label><p>{{ 'KILN_ALERTS.ALERT_TYPE' | translate }}:</p></ion-label><ion-input class="ion-text-right" readonly="true" [value]="selectedAlert.type"></ion-input>
      </ion-item>
      <ion-item>
        <ion-label><p>{{ 'KILN_ALERTS.FROM' | translate }}:</p></ion-label><ion-input class="ion-text-right" readonly="true" [value]="selectedAlert.kiln_name"></ion-input>
      </ion-item>
      <ion-item>
        <ion-label><p>{{ 'KILN_ALERTS.DATE' | translate }}:</p></ion-label><ion-input class="ion-text-right" readonly="true" [value]="selectedAlert.sent_time | date:'medium'"></ion-input>
      </ion-item>
      <ion-item>
        <ion-label><p>{{ 'KILN_ALERTS.EMAIL' | translate }}:</p></ion-label><ion-input class="ion-text-right" readonly="true" [value]="selectedAlert.email_sent_to ? selectedAlert.email_sent_to.join(', ') : ('KILN_ALERTS.NO_EMAILS_TO_SEND' | translate)"></ion-input>
      </ion-item>
      <ion-item>
        <ion-label><p>{{ 'KILN_ALERTS.TEXT_MSG' | translate }}:</p></ion-label><ion-input class="ion-text-right" readonly="true" [value]="selectedAlert.text_sent_to ? selectedAlert.text_sent_to.join(', ') : ('KILN_ALERTS.NO_PHONES_TO_SEND' | translate)"></ion-input>
      </ion-item>
      <ion-item *ngIf="selectedAlert.send_failures?.length" color="warning">
        <ion-label class="ion-text-wrap">
          <p><strong>{{ 'KILN_ALERTS.DELIVERY_FAILURES' | translate }}</strong></p>
          <ul class="delivery-failures-list">
            <li *ngFor="let failure of selectedAlert.send_failures">
              {{ failure.channel }} → {{ failure.recipient }}: {{ failure.error_message || ('KILN_ALERTS.DELIVERY_FAILURE_UNKNOWN' | translate) }}
            </li>
          </ul>
        </ion-label>
      </ion-item>
      <ion-item lines="no-lines" color="light-shade">
        <ion-label><p>{{ 'KILN_ALERTS.SUBJECT_LABEL' | translate }}:</p></ion-label><ion-input class="ion-text-right" readonly="true" [value]="selectedAlert.subject"></ion-input>
      </ion-item>
      <ion-item id="current-message-text">
        {{selectedAlert.message}}
      </ion-item>
    </ion-list>
  </div>
</div>
